import { type FiatCurrency } from '@capsicum/common';
import { type EnhancedWalletCurrency } from '@capsicum/features/wallet/shared';
import { useConversionRatesQuery } from '@capsicum/socios-core';

type UseTopupConversionRatesProps = {
	chzToFiatConversionRate?: string;
	cryptoCurrency?: EnhancedWalletCurrency;
	fiatCurrency?: FiatCurrency;
	fiatToChzConversionRate?: string;
};

export const useTopupConversionRates = ({
	chzToFiatConversionRate,
	cryptoCurrency,
	fiatCurrency,
	fiatToChzConversionRate
}: UseTopupConversionRatesProps) => {
	return {
		conversionCryptoCurrencyAmountText: fiatToChzConversionRate
			? `≈${Number(fiatToChzConversionRate).toFixed(2)} ${cryptoCurrency?.shortCode || ''}`
			: '',
		conversionDefaultCurrencyAmountText: chzToFiatConversionRate
			? `≈${Number(chzToFiatConversionRate).toFixed(2)} ${fiatCurrency?.currency.shortCode || ''}`
			: ''
	};
};

export const useSwitchCurrencyRates = (from?: FiatCurrency, to?: FiatCurrency) => {
	const {
		data: switchConversionRatesData,
		error,
		isLoading: isSwitchConversionsRatesLoading
	} = useConversionRatesQuery([
		{ from: from?.currency.id || to?.currency.id, to: to?.currency.id },
		{ from: to?.currency.id, to: from?.currency.id || to?.currency.id }
	]);

	return {
		error,
		isSwitchConversionsRatesLoading,
		switchConversionRatesData
	};
};
